import { Icon } from '@nimbus-ds/components';
import { EyeIcon, EyeOffIcon } from '@nimbus-ds/icons';
import './ShowHideAmountsIcon.scss';

interface ShowHideAmountsIconProps {
  onClick: () => void;
  eyeOff: boolean;
  fixed?: boolean;
}

function ShowHideAmountsIcon({
  onClick,
  eyeOff,
  fixed = false,
}: Readonly<ShowHideAmountsIconProps>) {
  const className = `stratus--clickable-icon ${
    fixed ? ' stratus--fixed-icon' : ''
  }`;

  return (
    <div className={className}>
      <Icon
        color="primary-interactive"
        source={eyeOff ? <EyeOffIcon size="small" /> : <EyeIcon size="small" />}
        onClick={onClick}
      />
    </div>
  );
}

export default ShowHideAmountsIcon;
